import { flatten } from "lodash";
import { governancaApi } from "../../../services/api";

export async function fetchBoletins({ idEvento, page = 1, pageSize = 8 }) {
  const res = await governancaApi.get("documento-evento", {
    params: {
      flag_del: 0,
      id_estabelecimento: 1,
      id_evento: idEvento,
      expand: "documento,arquivoDocumento",
      pageSize,
      page,
    },
  });

  if (res.data._meta.totalCount === 0) {
    return { boletins: [], totalPages: 0 };
  }

  const docs = res.data.items.map((item) => item.documento.arquivoDocumento);
  const boletins = flatten(docs);

  return {
    boletins,
    totalPages: res.data._meta.pageCount,
  };
}
